import script from "./base-textarea.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-textarea.vue?vue&type=script&setup=true&lang=ts"

import "./base-textarea.vue?vue&type=style&index=0&id=852eb3a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-852eb3a8"]])

export default __exports__